import { WhatsNewEntry } from "../../../core/models/entities/WhatsNewEntry";
import { WhatsNewEntryDto } from "../responses/WhatsNewDto";

// Picks the per-field text for the active language from `dto.translations`,
// keyed by base language code ("da-DK" -> "da"). Anything missing (or empty)
// falls back to the legacy Danish `title_da`/`body_da` when the language is
// Danish, then to the always-present English text - so old blob files (with or
// without the *_da fields) keep working.
export function mapToWhatsNewEntry(
  dto: WhatsNewEntryDto,
  language: string,
): WhatsNewEntry {
  const base = language.toLowerCase().split("-")[0];
  const tr = dto.translations?.[base];
  return {
    id: dto.id,
    date: dto.date,
    icon: dto.icon,
    title: tr?.title || (base === "da" && dto.title_da) || dto.title,
    body: tr?.body || (base === "da" && dto.body_da) || dto.body,
    // Omitted audience means the entry is for everyone.
    audience: dto.audience ?? "all",
  };
}
